import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const CONSENT_KEY = "besafe_cookie_consent_v1";
const COOKIE_POLICY_URL = "https://besafebroker.it/cookie-policy-ue/";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = window.localStorage.getItem(CONSENT_KEY);
      if (!saved) setVisible(true);
    } catch { setVisible(true); }
  }, []);

  const accept = () => {
    try { window.localStorage.setItem(CONSENT_KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() })); } catch { /* noop */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 p-4 sm:p-6 pointer-events-none"
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
    >
      <div className="max-w-3xl mx-auto bg-white border border-slate-200 shadow-xl rounded-2xl p-5 sm:p-6 pointer-events-auto fade-up">
        <div className="flex items-start gap-4">
          <div className="hidden sm:flex w-10 h-10 rounded-xl bg-[#0F7B85]/10 text-[#0F7B85] items-center justify-center shrink-0">
            <Cookie className="w-5 h-5"/>
          </div>
          <div className="flex-1">
            <h2 className="font-display text-base text-[#0F7B85]">Informativa cookie</h2>
            <p className="text-xs text-slate-600 mt-1.5 leading-relaxed">
              Utilizziamo <strong>esclusivamente cookie tecnici essenziali</strong> per la sessione di autenticazione.
              Nessun cookie di profilazione o tracciamento di terze parti. Continuando la navigazione accetti l&apos;uso di questi cookie.{" "}
              <a href={COOKIE_POLICY_URL} target="_blank" rel="noopener noreferrer" className="text-[#0F7B85] underline hover:text-[#0A5C64]" data-testid="cookie-banner-policy-link">Leggi la Cookie Policy ↗</a>.
            </p>
            <div className="mt-4 flex items-center gap-3">
              <button
                onClick={accept}
                data-testid="cookie-banner-accept-button"
                className="bg-[#0F7B85] hover:bg-[#0A5C64] text-white rounded-lg px-4 py-2 text-xs font-medium transition-colors"
              >
                Ho capito
              </button>
              <Link
                to="/privacy"
                data-testid="cookie-banner-privacy-link"
                className="text-xs text-slate-600 hover:text-[#0F7B85] hover:underline"
              >
                Privacy
              </Link>
            </div>
          </div>
          <button
            onClick={accept}
            aria-label="Chiudi informativa"
            className="text-slate-400 hover:text-slate-700 transition-colors"
          >
            <X className="w-4 h-4"/>
          </button>
        </div>
      </div>
    </div>
  );
}
